<template>
    <div @click="extLink(url)" class="card-data">
        <img class="img-size" :src="filename" alt="" srcset="">
        <div class="title-link">{{name}}</div>
    </div>
</template>

<script>
export default {
  name: 'LinkCard',
  props: [
    "name",
    "url",
    "filename"
  ],
  methods: {
    extLink(url) {
        window.open(url, '_blank');
    }
  }
}
</script>

<style>
.card-data {
    width: 100%;
    padding: 16px 8px;
    text-align: center;
    border-radius: 4px;
}
.card-data:hover {
    background-color: #e5baee;
    cursor: pointer;
}
.img-size {
    height: 64px;
}
.title-link {
    font-size: 2rem;
}
@media only screen and (max-width: 768px) {
    .img-size {
        height: 40px;
    }
    .title-link {
        font-size: 1.5rem;
    }
}
</style>